export class BadTaskNameError extends Error {}
